export const Releases = [
    {
        version: '1.1.0',
        year: 'התשפ"ג',
        programmers: 'אוריה אלפרין.',
        cName: 'releases'
    },
    {
        version: '0.0.1',
        year: 'התשפ"א',
        programmers: 'איתי שמחייב, ליהיא בלפר, יוסף שטיין.',
        cName: 'releases'
    },

]